import { useMutation, UseMutationOptions } from 'react-query'

import { fetchAndReturn } from 'data/utils/utils'

import { useToast } from 'ui/components/Toast'

import { invalidateAutomationConnections } from './useAutomationConnections'

export type AutomationConnectionCreateRequest = Omit<
    AutomationConnectionDto,
    '_sid' | 'stack_sid' | 'created_by_user_sid' | 'created_date' | 'modified_date'
>

export function useCreateAutomationConnection(
    options: UseMutationOptions<
        AutomationConnectionDto,
        unknown,
        AutomationConnectionCreateRequest
    > = {}
) {
    const toast = useToast()

    return useMutation(
        async (automationConnection: AutomationConnectionCreateRequest) => {
            return fetchAndReturn('automations/connections/', {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify(automationConnection),
            }) as Promise<AutomationConnectionDto>
        },
        {
            ...options,
            onError: async (error: any) => {
                console.warn('Creating automation connection failed', { error })
                toast({
                    title: 'There was a problem creating the automation connection. Please try again later.',
                    type: 'error',
                })
            },

            onSettled: async () => {
                await invalidateAutomationConnections()
            },
        }
    )
}
